<template>
  <div class="filter">
    <p class="flex-shrink-1 align-self-center">ประเภท:</p>
    <select
      class="custom-select w-100"
      v-model="selected"
      @change="optionSelected"
    >
      <option value="">ทั้งหมด</option>
      <option value="auction">ประมูล</option>
      <option value="luckydraw">จับฉลาก</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "FilterAction",

  props: {
    defaultSelected: {
      default: "",
    },
  },
  data() {
    return {
      selected: "",
    };
  },
  created() {
    this.selected = this.defaultSelected ? this.defaultSelected : "";
  },
  methods: {
    optionSelected() {
      this.$emit("input", this.selected);
      this.$emit("change", this.selected);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter {
  display: flex;
  padding: 16px;
  vertical-align: middle;

  > p {
    margin: 0px;
    width: 70px;
  }

  > select {
    height: auto;
    padding: 0px 12px;
    border-color: #ebedec;
  }
}
</style>
